import VerticalPage from "@/components/VerticalPage";
import { MEDIA } from "@/lib/content";

export default function Media() {
  return (
    <VerticalPage
      overline="Moaglee Media"
      title="AI-Powered Systems. Better Follow-Up. More Conversion."
      subtitle="Moaglee Media builds AI-powered marketing, CRM, content, and automation systems for business owners who need more visibility, better follow-up, and stronger lead conversion."
      image={MEDIA.waterfront}
      statement="Moaglee Media builds AI-powered marketing, CRM, content, and automation systems for business owners."
      bullets={[
        "AI marketing systems & content engines",
        "GoHighLevel (GHL) automation builds",
        "Social content systems at scale",
        "CRM follow-up & nurture sequences",
        "Inbound / outbound lead generation",
        "Business owner visibility & authority",
      ]}
      redirectKey="media"
      redirectLabel="Visit MoagleeMedia.com"
      forms={["media_audit"]}
      sourcePage="/media"
    />
  );
}
